import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { MessageTemplate } from './main-settings.model';

@Injectable({
  providedIn: 'root',
})
export class MainSettingsService {
  private url: string = environment.serverUrl;

  constructor(private http: HttpClient) {}

  fetchTemplates(): Observable<any> {
    return this.http.get(this.url + 'messageTemplates');
  }

  putTemplate(message: MessageTemplate): Observable<any> {
    return this.http.put(this.url + 'messageTemplates', message);
  }

  postTemplate(message: MessageTemplate): Observable<any> {
    return this.http.post(this.url + 'messageTemplates', message);
  }

  deleteTemplate(index: number): Observable<any> {
    return this.http.get(this.url + 'messageTemplates/' + index);
  }

  clearRequests(from: number, to: number): Observable<any> {
    return this.http.delete(this.url + 'clean?fromDate=' + from+ "&toDate=" + to);
  }

}
